import { createReducer } from '../../app/common/util/reducerUtil';
import { NET_BANKING_OPTIONS } from './DropDownConstants';

const initialState = {};

export const netBankingOptions = (state, payload) => {
  return {
    ...state,
    netBanking: payload,
  }
}

export default createReducer(initialState, {
  [NET_BANKING_OPTIONS]: netBankingOptions,
});